<template>
    <div>
        <div v-if="visible">
            <loading :active="isLoading"
                 :can-cancel="true"
                 :color="'#4cda64'"
                 :loader="'dots'"
                 :background-color="'#fff'"
                 :is-full-page="fullPage"/>
        </div>
    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    name : "inc_loading",
    components: {
        Loading
    },
    props: {
        visible: {
            type: Boolean,
            require: true,
            default: false
        },
    },
    watch: {
        visible: function (newVal) {
            if (newVal == true) {
                this.visible = true;
            } else {
                this.visible = false;
            }
        }
    },
    data: () => ({
        isLoading:true,
        fullPage:true
    }),
    mounted() {
    },
    methods: {
    }
}
</script>